module.exports = __webpack_public_path__ + "static/20min-c702c77c01fbedd9cd341fdf4c3d0dfa.png";